var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classes},[_c('div',{ref:"slot",staticClass:"toaster-slot"})])
}
var staticRenderFns = []

export { render, staticRenderFns }